const memberData = {
    "chineseName": "陳志明",
    "englishName": "Zhiming Chen",
    "mobilePhone": "0912-112-221",
    "mailingAddress": {
        "country": "TW",
        "city":"taipei",
        "district":"中正區",
        "street":"忠孝東路",
        "zipCode":"100"
    },
    "email": "chenZhiming@gmail.com",
    "contactPerson": {
        "sameAsStudentInformation": true,
        "name": "陳志明",
        "email": "chenZhiming@gmail.com",
        "mobilePhone": "0912-112-221",
    },
    "billInfo": {
        "identity": "company",
        "company": "股份有限公司",
        "department": "開發部門",
        "invoiceTitle": "股份有限公司",
        "invoiceType": "triplicate",
        "taxIdNo": "21338428",
    }
}

export default memberData;